/******************************************************************************************
 *	DOM Utility Methods
 *******************************************************************************************/
(function() {
  

  angular.module('rcServices.domUtility', []).service('DomUtility', function(_) {
    //Check if an element (child) is a descendant of another element (parent)
    this.isDescendant = function(child, parent) {
      var node = child.parentNode;
      while (node !== null) {
        if (node === parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    //Check if element is in viewport
    this.isElementInViewport = function(element) {
      var rect = element.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    };

    //Normalize key code from keyboard event
    this.getKeyCode = function(event) {
      return event.keyCode || event.which;
    };

    //Asynchronously load script.
    //You can optionally pass in a callback to be notified when loading is done.
    this.asyncLoadScript = function(url, successCallback, errorCallback) {
      if (!url || !_.isString(url)) {
        return;
      }

      var js = document.createElement('script');
      js.async = true;
      js.src = url;

      if (successCallback && _.isFunction(successCallback)) {
        js.addEventListener('load', successCallback, false);
      }

      if (errorCallback && _.isFunction(errorCallback)) {
        js.addEventListener('error', errorCallback, false);
      }

      //Insert newly create script tag before the first script tag on the page.
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(js, firstScriptTag);
    };
  });
})();
